<template>
  <div class="read-more">
    <span v-if= "textAdjusted" class="read-more-text">{{ textAdjusted }}</span>
    <span v-else class="read-more-text read-more-text-empty"><slot name="empty"></slot></span>&nbsp;
    <a v-if="isTextAdjusted && text && textAdjusted.length !== text.length"
      class="accent read-more-anchor"
      @click.passive="onClickReadMore"
    ><slot name="readMore">read more</slot></a>
  </div>
</template>
<script>
export default {
  props: {
    text: {
      type: String,
    },
    limit: {
      type: Number,
      default: 55,
    },
    limitByChar: {
      type:Boolean,
      default:false,
    },
  },
  data() {
    return {
      isTextAdjusted: true,
    };
  },
  computed: {
    textAdjusted() {
      if (this.isTextAdjusted) {
        return this.getAdjustedText(this.text);
      }
      return this.text;
    },
  },
  methods: {
    getAdjustedText(text) {
      if (!text) return '';
      const str = this.limitByChar ? '' : ' ';
      let tempArr;
      const { limit } = this;
      const buffer = 10;
      tempArr = text.trim().split(str);
      if (tempArr.length > limit + buffer) {
        tempArr.splice(limit, tempArr.length, '...');
        text = tempArr.join(str);
      }
      return text;
    },

    onClickReadMore() {
      this.isTextAdjusted = false;
    },
  },
};
</script>
<style lang="postcss">
.read-more {
  .read-more-text-empty {
    font-style: italic;
    color: var(--grey-light);
  }
}
</style>
